import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";
import {
  APPOINTMENT_STATUS_COLORS,
  APPOINTMENT_STATUS_LABELS,
} from "@/features/appointment/constants";
import type { AppointmentStatus } from "@/features/appointment/types";

interface AppointmentStatusBadgeProps {
  status: AppointmentStatus;
  className?: string;
}

export function AppointmentStatusBadge({
  status,
  className,
}: AppointmentStatusBadgeProps) {
  return (
    <Badge className={cn(APPOINTMENT_STATUS_COLORS[status], className)}>
      {APPOINTMENT_STATUS_LABELS[status]}
    </Badge>
  );
}
